import { render, staticRenderFns } from "./tableFinancialRatio.vue?vue&type=template&id=0253e660&scoped=true"
import script from "./tableFinancialRatio.vue?vue&type=script&lang=js"
export * from "./tableFinancialRatio.vue?vue&type=script&lang=js"
import style0 from "./tableFinancialRatio.vue?vue&type=style&index=0&id=0253e660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253e660",
  null
  
)

export default component.exports